<template>
  <div>
    <transition :name="$store.state.isLayoutSwitched ? 'slide-in-down' : 'slide-in-up'">
      <div class="bottom-bar" v-show="$store.state.isBottomBarVisible">
        <div class="bottom-bar__left">
          <a v-if="$store.state.selector" href="http://localhost:9000" class="selector-btn touch" :dir="language.dir">
            <span>{{ config.labels.exploreCommunities[language.code] || config.labels.exploreCommunities["en"] }}</span>
          </a>
          <button v-if="config.general?.showHomeButton" class="bottom-bar__home-button touch" @click="navigateHome">
            <div class="btn__icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" fill="currentColor"><path d="M303.5 13.7L288 .5 272.5 13.7l-264 224 31.1 36.6L64 253.5 64 488l0 24 24 0 400 0 24 0 0-24 0-234.5 24.5 20.8 31.1-36.6-264-224zM112 464l0-251.2L288 63.5 464 212.8 464 464l-80 0 0-168 0-24-24 0-144 0-24 0 0 24 0 168-80 0zm128 0l0-144 96 0 0 144-96 0z" /></svg>
            </div>
          </button>
          <ButtonBack />
          <div v-if="!$store.state.selector && config.general?.showSensorealBranding">
            <img class="bottom-bar__sensoreal-logo touch" src="/assets/sensoreal.png" @click="forceRefresh()" />
          </div>
          <div v-if="config.general?.showLayoutSwitchToggle" class="bottom-bar__layout-toggle">
            <button class="touch" @click="$store.commit('SET_IS_LAYOUT_SWITCHED', !$store.state.isLayoutSwitched)">
              <fa :icon="['fas', 'sync']" />
            </button>
          </div>
        </div>
        <div class="bottom-bar__center">
          <transition-group class="bottom-bar__nav-items" :class="{ 'dir-rtl': language.dir === 'rtl' }" @before-enter="beforeEnter" @enter="enter" @afterEnter="afterEnter" @leave="leave">
            <div v-for="(item, index) in activeNavItems" class="bottom-bar__nav-item-wrapper" :class="[{ 'bottom-bar__nav-item-wrapper--active': isNavItemActive(item) }, { 'bottom-bar__nav-item-wrapper--last-item': item.isLiveSection }]" :data-index="index" :key="item._id" :dir="language.dir">
              <router-link
                class="bottom-bar__nav-button touch"
                :class="[{ 'router-link-active': isNavItemActive(item) }, { 'bottom-bar__nav-button--live': item.isLiveSection }]"
                tag="button"
                :to="getItemLink(item)"
                @click.native="
                  triggerMedia(item.label['en']);
                  playClickSound();
                  bus.$emit('navClick');
                "
              >
                <div v-if="item.icon && item.icon[1]" class="icon">
                  <fa :icon="[config.iconSet, item.icon[1]]" />
                </div>
                <span class="bottom-bar__nav-label" v-html="item.label[language.code] || item.label['en']"></span>
              </router-link>
            </div>
          </transition-group>
        </div>
        <div class="bottom-bar__right">
          <div class="bottom-bar__nav-item-wrapper">
            <router-link v-if="config.general?.showFavourites" class="bottom-bar__nav-button bottom-bar__nav-button--favourites" :class="[{ touch: favourites.length }, { 'has-favourites': favourites.length }, { 'is-square': !favouritesButtonLabel }]" tag="button" :to="viewFavouriteLink">
              <div class="icon">
                <fa :icon="['far', 'heart']" />
              </div>
              <span class="bottom-bar__nav-label">{{ favouritesButtonLabel }}</span>
            </router-link>
          </div>
          <div v-if="languages.length > 1" class="bottom-bar__language-selector">
            <div v-for="lang in languages" class="bottom-bar__language-selector-button touch" :class="{ 'bottom-bar__language-selector-button--active': lang.code === language.code }" :key="lang.code" @click="setLanguage(lang)">
              <div>
                {{ lang.code }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import _ from "lodash";
import { bus } from "../main";
import ButtonBack from "./ButtonBack.vue";
import { isRouteActiveForPath } from "@/utils/livingRoute";

export default {
  props: ["nav-items"],

  components: {
    ButtonBack,
  },

  data() {
    return {
      activeNavItems: [],
      bus: bus,
    };
  },

  computed: {
    ...mapGetters({
      activePage: "activePage",
      backlink: "activeBackLink",
      favourites: "favourites/favourites",
      viewFavouriteLink: "favourites/viewFavouritesLink",
      languages: "languages",
      language: "language",
      config: "newConfig",
    }),

    defaultPage() {
      const categoryId = this.$store.state.route.params.categoryId;
      const navigation = _.find(this.$store.state.navigation, (navigation) => {
        return navigation._id === this.$store.state.route.params.categoryId;
      });

      if (navigation) {
        return navigation.defaultChildUrl ? navigation.defaultChildUrl : `/category/${categoryId}/page/${navigation.children[0].pageId}`;
      }

      return "/";
    },

    favouritesButtonLabel() {
      return this.config.labels.favouritesButton[this.language.code];
    },
  },

  watch: {
    navItems: {
      handler(oldNavItems, newNavItems) {
        if (!_.isEqual(oldNavItems, newNavItems)) {
          if (oldNavItems.length) {
            this.activeNavItems = [];
          }

          this.$store.commit("addAnimationToQueue", "BottomBar");
        }
      },
      immediate: true,
    },
  },

  mounted() {
    bus.$on("animateBottomBar", () => {
      if (!_.isEqual(this.activeNavItems, this.navItems)) {
        this.activeNavItems = this.navItems;
      } else {
        bus.$emit("finishedAnimation", "BottomBar");
      }
    });
  },

  methods: {
    ...mapActions([
      //'triggerVideo',
      "playClickSound",
    ]),

    handleBackClick() {
      if (this.backlink === "/") {
        if (this.$store.state.homeUrl) {
          if (this.$store.state.navMaster && this.$store.state.socket) {
            this.$store.state.socket.emit("navigatedExternalUrl", this.$store.state.homeUrl);
            setTimeout(() => {
              window.location.href = this.$store.state.homeUrl;
            }, 100);
          } else {
            window.location.href = this.$store.state.homeUrl;
          }
        } else {
          this.$router.push(this.backlink);
        }
      } else {
        this.$router.push(this.backlink);
      }
    },

    triggerMedia(pageName) {
      if (!pageName) return this.$store.dispatch("triggerVideo", "default");
      const formattedPageName = pageName.toLowerCase().replaceAll(" ", "-");
      this.$store.dispatch("triggerVideo", `${process.env.VUE_APP_PROJECT}_${formattedPageName}.mp4`);
      this.$store.dispatch("announceSwarmContext", formattedPageName);
    },

    navigateHome() {
      if (this.$store.state.homeUrl) {
        if (this.$store.state.navMaster && this.$store.state.socket) {
          this.$store.state.socket.emit("navigatedExternalUrl", this.$store.state.homeUrl);
          setTimeout(() => {
            window.location.href = this.$store.state.homeUrl;
          }, 100);
        } else {
          return (window.location.href = this.$store.state.homeUrl);
        }
      }
      this.$router.push(this.defaultPage);
    },

    beforeEnter(el) {
      el.style.opacity = 0;
      el.style.transform = "translateY(25%)";
    },

    enter(el, done) {
      setTimeout(() => {
        el.style.opacity = 1;
        el.style.transform = "translateY(0)";
        el.style.transition = `transform 0.6s cubic-bezier(0.33, 1, 0.68, 1), opacity 1.2s`;
        done();
      }, (parseInt(el.dataset.index) + 1) * 150);
    },

    afterEnter(el) {
      if (parseInt(el.dataset.index) + 1 === this.navItems.length) {
        bus.$emit("finishedAnimation", "BottomBar");
      }
    },

    leave(el) {
      el.style.opacity = 0;
      el.style.transform = "translateY(25%)";
      el.style.transition = `transform 0.4s cubic-bezier(0.32, 0, 0.67, 0), opacity 0.3s`;
    },

    getItemLink(item) {
      if (item.customRoute) {
        return item.customRoute;
      }

      return `/category/${this.$store.state.route.params.categoryId}/page/${item.pageId}`;
    },

    isNavItemActive(item) {
      if (item.customRoute) {
        if (isRouteActiveForPath(this.$route, item.customRoute)) {
          return true;
        }
      }

      if (item.isLiveSection && (this.$route.path.includes('/live') || this.$route.path.includes('/product/'))) {
        return true
      }

      return (
        this.activePage &&
        (item.pageId === this.activePage._id ||
          _.find(item.children, (child) => {
            return child.pageId === this.activePage._id;
          }))
      );
    },

    forceRefresh() {
      this.triggerMedia();
      if (this.$store.state.homeUrl) {
        const url = new URL(this.$store.state.homeUrl);
        window.location.href = url.origin;
      } else {
        window.location.href = window.location.origin;
      }
    },

    navigateToDefaultPage() {
      this.$router.push(this.defaultPage).catch(() => {});
    },

    setLanguage(lang) {
      this.$store.commit("SET_LANGUAGE", lang);
      setTimeout(() => {
        bus.$emit("startAnimations");
      }, 100);
    },
  },
};
</script>
<style lang="scss" scoped>
.bottom-bar {
  background-color: var(--bottombar-bg-color);
  bottom: 0;
  left: 0;
  height: 10rem;
  display: flex;
  position: absolute;
  width: 100%;
  z-index: var(--bottombar-z-index);

  .layout-switched & {
    bottom: initial;
    top: 0;
  }

  &__left {
    display: flex;
    gap: 2rem;
    width: 25rem;
    align-items: flex-start;
    padding: 2rem 0 2rem 4rem;
  }

  &__center {
    display: flex;
    flex-grow: 1;
    padding: 2rem 25rem 2rem 0;
    justify-content: center;
    position: relative;
    // width: 159rem;
  }

  &__home-button {
    display: flex;
    align-items: center;
    border: 0.1rem solid #fff;
    border-radius: var(--border-radius);
    flex-shrink: 0;
    height: var(--button-height);
    width: var(--button-height);

    .btn__icon {
      align-items: center;
      display: flex;
      justify-content: center;
      width: 100%;

      svg {
        width: 1.75rem;
      }
    }
  }

  &__nav-item-wrapper {
    &--last-item {
      margin: 0 2rem 0 auto;
      position: absolute;
      right: 0;

      &::before,
      &::after {
        content: "";
        position: absolute;
        top: 0;
        height: 100%;
        background: rgb(87, 89, 96);
        width: 1px;
      }

      &::before {
        left: -2rem;
      }

      &::after {
        right: -2rem;
      }
    }
  }

  &__nav-button {
    background: var(--button-background);
    border-radius: var(--border-radius);
    box-shadow: var(--button-box-shadow);
    color: var(--button-color);
    display: block;
    margin: 0 1rem;
    padding: var(--button-padding);
    line-height: 1;
    height: var(--button-height);
    width: var(--button-width);
    font-size: var(--button-font-size);
    text-transform: uppercase;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    .icon {
      margin-right: 0.8em;
    }

    &.router-link-active {
      background: var(--button-background-active);
      color: var(--button-color-active);
    }

    &--live {
      background: var(--button-live-background);
      color: var(--button-live-color);
    }

    &--favourites {
      opacity: 0.2;

      &.has-favourites {
        background: var(--button-favourites-background);
        color: var(--button-favourites-color);
        opacity: 1;
      }

      &.router-link-active.has-favourites {
        background: var(--button-background-active);
        color: var(--button-color-active);
      }

      &.is-square {
        aspect-ratio: 1;
        height: var(--button-height);
        margin: 0 8rem 0 1rem;
        width: unset;

        .btn__icon svg {
          margin: auto;
        }
      }
    }
  }

  &__right {
    display: flex;
    width: 32.5rem;
    padding: 2rem;
  }

  &__language-selector {
    display: flex;
    gap: 1rem;
    position: relative;
    top: 0;
    left: 0;
    z-index: 1000;
  }

  &__language-selector-button {
    aspect-ratio: 1;
    border: 0.1rem solid white;
    border-radius: 0.5rem;
    height: var(--button-height);
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 2.2rem;
    text-align: center;
    text-transform: uppercase;
    opacity: 0.5;

    &--active {
      opacity: 1;
    }
  }

  &__layout-toggle {
    opacity: 0.5;
    position: absolute;
    bottom: 0.5rem;
    left: 0.5rem;
    z-index: 1000;

    button {
      font-size: 1.6rem;
    }

    .layout-switched & {
      bottom: initial;
      left: 0.5rem;
      top: 0.5rem;
    }
  }

  &__main {
    align-items: center;
    background-color: var(--bottombar-bg-color);
    bottom: 0;
    display: flex;
    flex-grow: 1;
    height: 10rem;
    justify-content: center;
    padding: 1.9rem 0;
  }

  &__sub {
    align-items: flex-start;
    background-color: var(--bottombar-bg-color);
    display: flex;
    justify-content: flex-end;
    padding: 1.9rem 7.9rem 1.9rem 5rem;
    position: relative;
    width: 32.5rem;
    .layout-switched & {
      align-items: flex-end;
    }

    .layout-switched & {
      align-items: flex-end;
    }
  }

  &__nav-items {
    align-self: flex-start;
    display: flex;
    justify-content: center;
    width: 100%;

    .layout-switched & {
      align-self: flex-end;
    }
  }

  .selector-btn {
    position: absolute;
    left: 4.3rem;
    bottom: 1rem;
    display: block;
    border: 0.01rem solid #fff;
    border-radius: 0.5rem;
    font-size: 1rem;
    opacity: 0.6;
    padding: 0.5rem 0.6rem 0.4rem;
    margin-left: -0.3rem;
    text-align: center;
    text-transform: uppercase;
  }

  &__sensoreal-logo {
    position: absolute;
    // bottom: 1rem;
    // right: 7.9rem;
    bottom: 1.5rem;
    left: 4rem;
    width: 8.65rem;
    z-index: 1;
  }

  &__version {
    color: rgba(255, 255, 255, 0.25);
    display: block;
    text-align: right;
  }
}
</style>
